export enum BookingType {
    CustomerBookableOrder = 'CustomerBookableOrder',
    AdminBookableOrder = 'AdminBookableOrder',
    NonBookableOrder = 'NonBookableOrder'
}
